import { StyleSheet } from "react-native";
import { Dimensions, Platform } from 'react-native';


const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;
const halfWidth = (windowWidth / 2);
const screenHeight = windowHeight - 30
const os = Platform.OS

let ORANGE = '#FF6600';
let LIGHTBLUE  = '#00B4FF';
let DARKBLUE = '#393BB2';
let YELLOW = '#fff605';



const PPSstyles = StyleSheet.create({
    roundedBackgoundBoxGray:{
        margin: 10, 
        backgroundColor: '#D3D3D3', 
        padding: 5, 
        borderRadius: 6,
        marginTop: 10,
        marginBottom: 2
    },
    roundedBackgoundBoxGrayBlackFont:{
        margin: 15, 
        backgroundColor: '#D3D3D3', 
        padding: 10, 
        borderRadius: 6,
        marginTop: 10,
        marginBottom: 0,
        color: 'black',
        height: 55
    },
    arrowImageStyle:{
      width:30,
      height: 30,
      marginTop: 15,
      alignSelf: 'flex-start'
    },
    roundedBackgoundBoxWhite:{
      margin: 10, 
      backgroundColor: 'white', 
      padding: 0, 
      borderRadius: 6,
      marginTop: 2,
      marginBottom: 2
  },
  roundedBackgoundBoxBlue:{
    margin: 10, 
    backgroundColor: '#ADD8E6', 
    padding: 0, 
    borderRadius: 6,
    marginTop: 2,
    marginBottom: 2
},
roundedBackgoundBoxYellow:{
    margin: 10, 
    backgroundColor: '#ffffe0',
        margin: 10, 
        backgroundColor: '#ffffe0', 
        padding: 0, 
        borderRadius: 6,
        marginTop: 2,
        marginBottom: 2
    },
    roundedBackgoundBoxRed:{
        margin: 15, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius: 8,
        marginTop: 2,
        marginBottom: 2,
        alignItems: 'center',
        height: 55,
        width: '90%'
    },
    roundedBackgoundBoxRedTall:{
        margin: 15, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius: 8,
        marginTop: 2,
        marginBottom: 2,
        alignItems: 'center',
        height: 70,
        width: '90%'
    },
    modalroundedBackgoundBoxRed:{
        margin: 0, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius: 12,
        marginTop: 2,
        marginBottom: 2,
        alignItems: 'center',
        height: 55,

        width: '100%'
    },
    roundedBackgoundBoxSmallRed:{
        margin: 10, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius: 6,
        marginTop: 5,
        marginBottom: 2,
        alignSelf: 'center',
        width: '100%',
        height: 30
        
    },
    backroundedBackgoundBoxSmallRed:{
        margin: 10, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius:10,
        marginTop: 10,
        marginBottom: 2,
        alignSelf: 'center',
        width: '40%',
        height: 40
    },

    simplebackbuttonBoxSmallRed:{
        margin: 10, 
        backgroundColor: 'maroon', 
        padding: 0, 
        borderRadius:10,
        marginTop: 10,
        marginBottom: 2,
        height: 40
    },
    backroundedBackgoundBoxSmallGray:{
        margin: 10, 
        backgroundColor: 'lightgray', 
        padding: 0, 
        borderRadius:10,
        marginTop: 10,
        marginBottom: 2,
        borderWidth: 1,
        borderColor: 'gray',
        alignSelf: 'center',
        width: '40%',
        height: 40
        
    },
    roundedBackgoundBoxSmallYellowRight:{
        margin: 10, 
        backgroundColor: '#ffffe0', 
        padding: 0, 
        borderRadius: 6,
        marginTop: 5,
        marginBottom: 2,
        alignItems: 'flex-end',
        
    },
    container:{
        alignItems: 'center', 
        height: ( os === 'ios' ? screenHeight - 40:screenHeight),
        marginTop: ( os === 'ios' ? 48:30),
        width: ( os === 'ios' ? windowWidth : windowWidth),
        backgroundColor: 'white'
        
    },
    bodyContainer:{
        alignItems: 'center', 
        //justifyContent:'center', 
        //flex: 1,
        height: screenHeight,
        marginTop: ( os === 'ios' ? 50:0),
        width: ( os === 'ios' ? windowWidth : windowWidth)
        
        },
        bodyWidth:{
            width: ( os === 'ios' ? windowWidth : windowWidth)
            },
    headerContainer:{
        alignItems: 'center',
        //flex : 1,
        //height:'100%',
        height: 900,
        marginTop: 50,
        width:'100%'
        },
    hotlineContainer:{
        alignItems: 'center', 
        justifyContent:'center', 
        //flex: 1,
        //height: '100%'
    },
    moduleContainer:{
        // flex: 1,
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        width: '100%',
        // backgroundColor:'grey',
        // marginBottom: 100,
        marginTop: 60,
        height: 100
    },
    smallContainer:{
        // flex: 1,
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        width: '100%',
        // backgroundColor:'grey',
        // marginBottom: 100,
        marginTop: 10,
        height: 60
    },
    smallContainerNoTop:{
        // flex: 1,
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        width: '100%',
        // backgroundColor:'grey',
        // marginBottom: 100,
        //marginTop: 0,
        height: 70
    },
    smallContainerColumns:{
        //flex: 1,
        //justifyContent: 'space-evenly',
        flexDirection: 'column',
        width: '100%',
        // backgroundColor:'grey',
        // marginBottom: 100,
        alignItems: 'center',
        height: '15%'
    },
    selectBox:{
        width: windowWidth, 
        height: 250, 
        //position:'absolute',
        marginTop:70,
    },
    selectSmallBox:{
        width: windowWidth, 
        height: 80, 
        //position:'absolute',
        marginTop:20,
        fontSize: 15,
        fontWeight: 'bold'
    },
    button: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 12,
      paddingHorizontal: 32,
      borderRadius: 4,
      elevation: 3,
      backgroundColor: 'maroon',
      width: halfWidth,
      height: 50,
      padding: 20,
    },
    text: {
      fontSize: 16,
      lineHeight: 21,
      fontWeight: 'bold',
      letterSpacing: 0.25,
      color: '#000',
      //marginLeft:5
    },
    textLight: {
        fontSize: 16,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#000',
        //marginLeft:5,
        alignItems: 'center',
        //marginTop: 15
    },
    textLightnoTop: {
        fontSize: 16,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: 'white',
        marginLeft:5,
        alignItems: 'center',
        marginTop: 0
    },
    textSubTitle: {
        fontSize: 16,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: 'white',
        marginLeft:5,
        alignItems: 'center'
        
    },
    textMedium: {
        fontSize: 18,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#000',
        fontWeight: 'bold'
        /* marginLeft:5,
        alignSelf: 'center',
        alignItems: 'center',
        marginTop:8
 */    },
    textTitle:{
        margin: 1, 
        padding: 5, 
        fontWeight: 'bold',
        fontSize: 20,
        marginLeft: 10
    },
    textBody:{
        fontSize: 8, 
        margin: 5, 
        marginBottom: 8,
        marginLeft:10
    },
    textBody15:{
        fontSize: 15, 
      margin: 5, 
      marginBottom: 8,
      fontWeight: 'normal',
      color: 'gray'
  },
  textBody20gray:{
    fontSize: 20, 
    margin: 5, 
    marginBottom: 8,
    color: 'gray'
},
  textBody20:{
    fontSize: 20, 
    margin: 5, 
    marginBottom: 8,
    fontWeight: 'bold',
    alignSelf: 'center'
},
    input: {
        height: 50, 
        borderWidth:1, 
        borderColor:'#555555',
        width: '45%',
        borderRadius: 5,
        padding: 10,
        marginTop: 10,
        justifyContent: 'space-evenly',
        alignItems: 'center'

    },
    input3box: {
        height: 50, 
        borderWidth:1, 
        borderColor:'#555555',
        width: '30%',
        borderRadius: 5,
        padding: 10,
        marginTop: 5,
        justifyContent: 'space-evenly',
        alignItems: 'center'

    },
    inputResult:{
        height: 50, 
        borderWidth:1, 
        borderColor:'#deafaf',
        width: '80%',
        borderRadius: 5,
        padding: 10,
        backgroundColor: '#deafaf',
        fontSize: 20,
        textAlign:'center',
        color: 'white'
    },
    headerText:{
        fontSize: 20, 
        color: 'maroon', 
        textAlign: 'center',
        fontWeight: 'bold',
        marginRight: 90
    },
    icon:{
        width: 80,
        height: 80,
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20
    },
    iconSmall:{
        width: 60,
        height: 60,
        borderWidth: 1 ,
        borderColor: 'gray',
        backgroundColor: '#FFEAEA',
        borderRadius: 10,
        alignSelf:'center',
        padding: 10
    },
    iconImage:{
        width: '100%',
        height: '100%'
    },
    iconImageDubowitz:{
        width: 90,
        height: 56
    },
    iconText:{
        textAlign: 'center',
        fontSize: 16
    },
    iconTextSmall:{
        textAlign: 'center',
        fontSize: 12
    },
    iconTextRight:{
        textAlign: 'right',
        fontSize: 16
    },
    header:{
        height: 50,
        marginTop: 35,
        marginBottom: 20,
        borderBottomColor: '#000',
        // borderBottomWidth: 0.5,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        shadowOpacity: 0.2,
        shadowColor: '#000',
        elevation: 2
    },
    titleHeader:{
      width: '100%',
      height: 65,
      backgroundColor: '#ffea61',
      borderRadius: 5,
      //padding: 2,
      alignItems: "center",
     
  },
  titleHeaderGray:{
    width: '100%',
    height: 65,
    backgroundColor: '#bfbfbf',
    borderRadius: 0,
    borderwidth: 1,
    borderColor: DARKBLUE,
    //padding: 2,
    alignItems: "center",

    
},
datePickerStyle: {
    width: 200,
    marginTop: 20,
    fontWeight: 'bold'
  },

  titleText:{
    width: 350,
    height: 50,
    color: "#4169e1",
    fontSize: 18,
    borderRadius: 5,
    padding: 0,
    fontWeight: "bold",
    marginTop: 5
    
},
titleTextMid:{
    width: 350,
    height: 50,
    color: "white",
    fontSize: 18,
    borderRadius: 5,
    padding: 0,
    fontWeight: "bold",
    marginTop: 18
},
imageslide:{
    width: windowWidth,
    height: windowHeight,
    backgroundColor: '#FFEAEA',
    borderRadius: 0,
    padding: 0,
    marginTop: 20,
    flex: 1
},
imageslideBig:{
    width: '100%',
    height: '100%',
    backgroundColor: '#FFEAEA',
    borderRadius: 0,
    padding: 0,
    marginTop: 5
    
},

headerContainertoponly:{
    alignItems: 'center',
    //flex : 1,
    height:60,
    marginTop: 50,
    width:'100%'
    },
centeredView: {
    flex: 1,
    width:'100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -100,
    backgroundColor: DARKBLUE,
    fontFamily:'Helvetica',
    opacity:1

  },

  centeredPrompt: {
    flex: 1,
    width:'100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 0,
    fontFamily:'Helvetica',

  },

  modalcenteredView: {
    //flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 63,
    marginTop: 0,
    width: 300,
    height: 300
  },
  modalcenteredViewBig: {
    //flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 63,
    marginTop: 0,
    width: 350,
    height: 500
  },
  modalView: {
    margin: 0,
    borderWidth:1,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 5,
      height: 7,
    },
    shadowOpacity: 0.5,
    shadowRadius: 4,
    elevation: 5,
    width: 350,
    height: 400
  },

  modalCalendar: {
    marginLeft: 0,
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 10,
    //alignItems: 'center',
    borderWidth: 1,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 7,
    },
    shadowOpacity: 0.50,
    shadowRadius: 4,
    elevation: 5,
    justifyContent:'flex-start',
    width: 370,
    height: 400
  },

  modalPrompt: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 20,
    borderWidth:1,
    padding: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 7,
    },
    shadowOpacity: 0.5,
    
    shadowRadius: 4,
    elevation: 5,
    width: 360,
    height: 300
  },
  modalViewBig: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 10,
    alignItems: 'center',
    borderWidth: 1,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 7,
    },
    shadowOpacity: 0.50,
    shadowRadius: 4,
    elevation: 5,
    justifyContent:'center',
    width: 380,
    height: 550
  },
  
  modalViewPriceList: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 25,
    borderwidth:1,
    alignItems: 'center',
    shadowColor: 'gray',
    shadowOffset: {
      width: 2,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: 520,
    height: 420
  },

  modalViewWide: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 25,
    borderwidth:1,
    alignItems: 'center',
    shadowColor: 'gray',
    shadowOffset: {
      width: 2,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: 360,
    height: 550
  },

  modalToast: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 50,
    borderWidth:1,
    padding: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 7,
    },
    shadowOpacity: 0.5,
    
    shadowRadius: 4,
    elevation: 5,
    width: 250,
    height: 100
  },

  modalCalendarView: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 5,
    
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: 350,
    height: 600
  },
  modalViewSmall: {
    margin: 0,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: 250,
    height: 300
  },
  buttonOpen: {
    //backgroundColor: '#F194FF',
    backgroundColor: 'orange'
  },
  buttonClose: {
    backgroundColor: DARKBLUE,
  },
  tableBoxSmall: {
    width : 100,
    height : 60,
    justifyContent : 'center',
    borderWidth : 1,
    padding: 1,
    borderColor : 'gray'
  },
  tableHeader: {
    width : 100,
    height : 50,
    justifyContent : 'center',
    borderWidth : 1,
    borderColor : 'gray'
  },
  tableBoxFont: {
    fontFamily: 'Helvetica',
    fontSize:10,
    
    justifyContent: 'center',
    color:'gray',
    alignSelf:'center',
    fontWeight: 'bold'
    
},
  tableBoxSmallNoBorder: {
    width : 100,
    height : 60,
    borderWidth : 0,
    justifyContent : 'center',
    borderLeftWidth: 1,
    //borderLeftColor : 'gray'
  },
  folderListBox:{
    width:380, 
    flexDirection: 'row', 
    marginLeft:0, 
    height: 47, 
    padding:5, 
    borderRadius: 20, 
    borderWidth: 1, 
    marginTop:10, 
     borderColor: 'gray'
  },
  incrementBox:{
    width: 30, 
    height: 30, 
    borderRadius:5, 
    marginTop:0, 
    backgroundColor:ORANGE,
    padding:2
  },
  flightsBox:{
    width: 30, 
    height: 30, 
    borderRadius:5, 
    marginLeft:5, 
    marginTop: 0,
    backgroundColor:DARKBLUE,
    padding:2
  },
  addtocartBox:{
    width:50, 
    height:30, 
    borderRadius:5, 
    backgroundColor:DARKBLUE
  },
  PaxCountBox:{
    width: 30, 
    height: 30, 
    padding:5, 
    borderWidth: 1, 
    textAlign:'center',
    borderColor: 'gray',
    marginLeft:3,
    marginRight:3
  }
})
  export default PPSstyles;

